export default "__VITE_ASSET__Bb8Hsilg__"